/**
 * TurtleTeach Logo Icon
 */

import { SvgIcon, SvgIconProps } from '@mui/material';

export function TurtleTeachIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 34 18">
      <path
        d="M17.2823 0.741211C11.2006 0.741211 6.27051 5.67136 6.27051 11.753H28.2941C28.2941 5.67136 23.3639 0.741211 17.2823 0.741211Z"
        fill="#FFA425"
      />
      <path
        d="M3.51759 9C2.35322 9 1.35768 9.72288 0.955278 10.7443C0.746298 11.2748 1.22685 11.7529 1.797 11.7529H6.27054C6.27054 10.2325 5.038 9 3.51759 9Z"
        fill="#F7E0C0"
      />
      <path
        d="M28.2942 11.753C28.2942 9.18243 30.0557 7.02332 32.4375 6.41696C33.1742 6.22941 33.8001 6.86334 33.8001 7.62354L33.8001 10.3765C33.8001 11.1367 33.1838 11.753 32.4236 11.753L28.2942 11.753Z"
        fill="#FFA425"
      />
      <path
        d="M28.2942 11.753C28.2942 14.3236 26.5326 16.4827 24.1508 17.089C23.4141 17.2766 22.7883 16.6426 22.7883 15.8824L22.7883 11.753L28.2942 11.753Z"
        fill="#F7E0C0"
      />
      <path
        d="M11.7764 11.753C11.7764 14.3236 10.0148 16.4827 7.63302 17.089C6.89632 17.2766 6.27048 16.6426 6.27048 15.8824L6.27048 11.753L11.7764 11.753Z"
        fill="#F7E0C0"
      />
    </SvgIcon>
  );
}

